import useSWR from 'swr';
import { getSession } from './api';
import { toApiError } from './errors';
import { shouldPoll, UiState } from './screens';
import { ILendingSession } from './types';

export const SESSION_KEY = 'lending-session';
const POLL_MS = 4000;

/**
 * The session is the only source of truth for where the application is. It is polled while the backend works
 * (checks, statement analysis, scoring, payment confirmation, funding) and left alone while the customer acts;
 * writes put the session they return straight into the cache.
 */
export const useSession = (ui: UiState) => {
  const { data, error, isLoading, mutate } = useSWR<ILendingSession>(SESSION_KEY, getSession, {
    refreshInterval: (latest) => (shouldPoll(latest, ui) ? POLL_MS : 0),
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });
  return {
    session: data,
    error: error ? toApiError(error) : null,
    isLoading,
    /** Replace the cached session with one a write returned, without refetching. */
    setSession: (session: ILendingSession) => mutate(session, { revalidate: false }),
    refresh: () => mutate(),
  };
};
